//File used to hold dummy/defaul data to prevent component bloating with repeated data

export const MEETING_PAYLOAD = {
  openSide: undefined,
  meetingInfo: undefined,
  fullScreen: undefined,
  showCall: undefined,
  callObject: undefined,
  recording: undefined,
  recordingId: undefined,
  showCall: false,
};

export const FORM_FIELDS = {
  title: "",
  description:
    process.env.NODE_ENV === "development"
      ? `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Consectetur vel neque praesentium commodi id porro, aliquid, optio iste laborum maxime itaque consequuntur ullam rerum ratione corporis veritatis molestiae veniam at.`
      : "",
  capacity: null,
  banner:
    process.env.NODE_ENV === "development"
      ? "https://s3.us-east-2.amazonaws.com/cdn.qalort.com/users%2F608150b2abd7c02b72088d6e%2Fqhsd2%2F-6135e9cf-26f2-470d-989a-50322af480a8.jpeg"
      : "",
  start_date: "",
  end_date: "",
  price: 0,
  currency: "USD",
  frequency: null,
  images: [],
  schedules: [],
  recording: false,
};
